import { ADD_IMAGE, CLEAR_IMAGES, LOADING_IMAGE, STOP_LOADING_IMAGE } from '../types'

const initialState = {
  loading: false,
  images: [],
}

const imageReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_IMAGE:
      return {
        ...state,
        images: [
          ...state.images,
          {
            imgUrl: action.payload.imgUrl,
            imgLeft: action.payload.imgLeft,
            imgTop: action.payload.imgTop,
            imgHeight: action.payload.imgHeight,
            imgWidth: action.payload.imgWidth,
            angle: action.payload.angle,
            pageNumber: action.payload.pageNumber,
            offsetLeft: action.payload.offsetLeft,
            offsetTop: action.payload.offsetTop,
            multiplier: action.payload.multiplier,
            pageHeight: action.payload.pageHeight,
            type: action.payload.type,
          },
        ],
      }

    case CLEAR_IMAGES:
      return initialState

    case LOADING_IMAGE:
      return {
        ...state,
        loading: true,
      }

    case STOP_LOADING_IMAGE:
      return {
        ...state,
        loading: false,
      }

    default:
      return state
  }
}

export default imageReducer
